export default __webpack_public_path__ + "ad19f00.png";